var React = require('react');

var MatchMediaItem = {
  contextTypes: {
    mediaQueries: React.PropTypes.object
  }
};

module.exports = MatchMediaItem;



//////////////////
// WEBPACK FOOTER
// ./~/radium/modules/mixins/match-media-item.js
// module id = 142
// module chunks = 0